import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-flex__container" }
const _hoisted_3 = { class: "gfu-table-meta-more__label" }
const _hoisted_4 = { class: "_flex _jc-sb _mb-2" }
const _hoisted_5 = { class: "gfu-flex__container--vertical" }
const _hoisted_6 = {
  class: "gfu-heading",
  "data-qa": "your-pledge:orderPublicID"
}
const _hoisted_7 = { class: "_tc--lighter _fw-n gfu-bt--caption _my-0" }
const _hoisted_8 = { class: "_flex gfu-table-meta__items _row-gap-2 _col-gap-3 _jc-fs" }
const _hoisted_9 = {
  key: 0,
  class: "_pa-2 _br-2 _rounded--common _bg-color-light _flexinline"
}
const _hoisted_10 = {
  class: "_ml-1 gfu-hd",
  "data-qa": "your-pledge:OrderStage"
}
const _hoisted_11 = {
  key: 1,
  class: "_pa-2 _br-2 _rounded--common _bg-color-light _flexinline"
}
const _hoisted_12 = {
  class: "_ml-1 gfu-hd",
  "data-qa": "your-pledge:OrderPaymentStatus"
}
const _hoisted_13 = {
  key: 0,
  "data-qa": "order-summmary:StatusExplanation"
}
const _hoisted_14 = { class: "_flexwrap _ai-c _gap-3" }
const _hoisted_15 = {
  key: 1,
  class: "gfu-flex__container _mt-3"
}
const _hoisted_16 = { class: "_flex gfu-flex__container--vertical gfu-flex__item--grow _tc--dark" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  "data-qa": "order-summmary-status-explanation:Next"
}
const _hoisted_19 = { class: "_fw-eb" }
const _hoisted_20 = {
  key: 1,
  class: "gfu-table-meta__labels",
  "data-qa": "your-pledge-labels"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_order_extra_charged_notifications = _resolveComponent("order-extra-charged-notifications")
  const _component_base_button = _resolveComponent("base-button")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_circle_icon = _resolveComponent("circle-icon")
  const _component_base_badge = _resolveComponent("base-badge")

  return (_openBlock(), _createElementBlock("div", {
    "data-qa": `order-summary:${$props.pledge.orderPublicID}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      ($props.isExpandable)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            class: "_mr-3 gfu-table-meta-more _shrink-0",
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('expand')), ["prevent"])),
            "data-qa": "your-pledge-button:ShowMore"
          }, [
            _createVNode(_component_base_icon, {
              name: $options.expandButtonIcon,
              class: "gfu-table-meta-more__icon"
            }, null, 8 /* PROPS */, ["name"]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.YourPledge.ShowMoreButton), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass($options.projectMetaClasses)
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString($options.orderPublicIdHeaderText), 1 /* TEXT */),
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.Resources.format(_ctx.Resources.YourPledge.PledgeDateSubheader, $options.createDateFormatted)), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          ($options.isOrderStageVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.OrderStageLabel) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_10, _toDisplayString($options.orderStageName), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          ($options.isPaymentStatusVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.OrderPaymentStatusLabel) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString($options.orderPaymentStatusName) + " ", 1 /* TEXT */),
                  (_openBlock(), _createBlock(_component_tooltip, {
                    key: $options.orderPaymentStatusTooltip,
                    text: $options.orderPaymentStatusTooltip
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: "#",
                        class: "gfu-link gfu-link--nofx",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createVNode(_component_base_icon, { name: "circle-info" })
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["text"]))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.orderStatusExplanation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_order_extra_charged_notifications, {
                "order-communications": $props.orderCommunications,
                class: "_mt-3"
              }, null, 8 /* PROPS */, ["order-communications"]),
              ($options.orderStatusExplanation.type === 'notificator')
                ? (_openBlock(), _createBlock(_component_base_notificator, {
                    key: 0,
                    "can-close": false,
                    class: "_mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString($options.orderStatusExplanation.text) + " ", 1 /* TEXT */),
                        ($options.orderStatusExplanation.button)
                          ? (_openBlock(), _createBlock(_component_base_button, {
                              key: 0,
                              enabled: _ctx.isOrderValid,
                              class: _normalizeClass(['_shrink-0 _ml-a', { 'gfu-1of1': $options.isMobile }]),
                              theme: "transparentInverse",
                              onClick: $options.ctaTriggered,
                              "data-qa": "your-pledge-notification-button:ResumePayment"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($options.orderStatusExplanation.button), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["enabled", "class", "onClick"]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              ($options.orderStatusExplanation.type === 'tick')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_circle_icon, {
                      icon: "check",
                      theme: "success",
                      size: "large",
                      class: "_mr-2 _shrink-0"
                    }),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("strong", null, _toDisplayString($options.orderStatusExplanation.text), 1 /* TEXT */),
                      ($options.orderStatusExplanation.sub)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($options.orderStatusExplanation.sub), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($options.orderStatusExplanation.next)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", {
                              class: _normalizeClass($options.dividerClasses)
                            }, null, 2 /* CLASS */),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.Resources.YourPledge.OrderStageNextHintTitle), 1 /* TEXT */),
                            _createTextVNode(" " + _toDisplayString($options.orderStatusExplanation.next), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    ($options.hasInstallmentPlanWithInsufficientPaymentDetails)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          type: "warning",
          "can-close": false,
          class: "_mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass($options.installmentPlanWithInsufficientPaymentDetailsNotificatorClasses)
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.Resources.YourPledge.InstallmentPlanWithInsufficientPaymentDetailsDescription), 1 /* TEXT */),
              _createVNode(_component_base_button, {
                class: "_shrink-0 _grow-1",
                theme: "transparentInverse",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('update-payment-details'))),
                "data-qa": "notificator-button:UpdatePaymentDetails"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.InstallmentPlanWithInsufficientPaymentDetailsButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($props.labels.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.labels, (label) => {
            return (_openBlock(), _createBlock(_component_base_badge, {
              key: label.text,
              "data-qa": `your-pledge-label:${label.qa}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(label.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}